/**
 * Data returned by the useReplyRecommendation hook
 */
export type ReplyRecommendationHookData = {
    isRegenerating: boolean;
    regenerateMessage: () => Promise<string | undefined>;
};

/**
 * The reason for requiring a popconfirm
 */
export type AutoReplyPopConfirmReason =
    | 'old-message'
    | 'disabled-when-received'
    | 'conversation-signals';

/**
 * Auto reply next action status
 */
export const AUTO_REPLY_STATUS = {
    SKIP: 'skip',
    SEND: 'send',
    DEFER: 'defer',
    STOP: 'stop',
} as const;

/**
 * Status types for auto reply next action
 */
export type AutoReplyStatus = ValueOf<typeof AUTO_REPLY_STATUS>;

/**
 * Data returned by the useAutoReply hook
 */
export type AutoReplyResult = {
    /** Function to toggle the auto reply */
    onToggle: (connectionId: string, isEnabled: boolean) => Promise<void>;
    /** Whether the auto reply indicator should be shown */
    isIndicatorShown: boolean;
    /** Whether auto reply is enabled */
    isEnabled: boolean;
    /** Whether auto reply is paused */
    isPaused: boolean;
    /** Whether auto reply toggle is updating */
    isUpdating: boolean;
    /** Whether toggling auto reply requires a popconfirm */
    requirePopconfirm: boolean;
    /** The reason for requiring a popconfirm */
    requirePopconfirmReason?: AutoReplyPopConfirmReason;
};

/**
 * Parameters passed to the useAutoReply hook
 */
export type AutoReplyParams = {
    /** Whether the auto reply is enabled for the campaign */
    isEnabledForCampaign: boolean;
    /** Whether the auto reply is enabled for the connection */
    isEnabledForConnection: boolean;
    /** Whether the last message was received */
    isLastMessageReceived: boolean;
    /** Whether auto reply will reply to the last message */
    autoReplyStatus?: AutoReplyStatus;
};
